import { Injectable, inject } from '@angular/core';
import { LocationTypesService } from '@control-tower/platform-core';
import { LoggerService } from '@pf/shared-services';
import {
    AbstractTypeEntityFacade,
    TypeEntityStore,
} from '@pf/shared/util-platform';
import { TypeEntityTypes } from '@pf/shared-common';

@Injectable()
export class LocationTypeFacade extends AbstractTypeEntityFacade<LocationTypesService> {
    constructor() {
        const locationTypeService = inject(LocationTypesService);
        const store = inject(TypeEntityStore);
        const logger = inject(LoggerService);

        super(
            store,
            logger,
            locationTypeService,
            'locationTypeGetAll',
            TypeEntityTypes.LocationType
        );
    }
}
